import React from 'react';
import { FormGroup, FormControlLabel, Switch, LinearProgress } from '@mui/material';
import { handleLight1Change, handleLight2Change, handleDisplayChange } from '../utils/clientUtils';
import { useTranslation } from 'react-i18next';

function DeviceControls({ deviceStatus, deviceID, online }) {
    const { t } = useTranslation();

    const [light1, setLight1] = React.useState(deviceStatus.light_1);
    const [light2, setLight2] = React.useState(deviceStatus.light_2);
    const [display, setDisplay] = React.useState(deviceStatus.display);

    React.useEffect(() => {
        setLight1(deviceStatus.light_1);
        setLight2(deviceStatus.light_2);
        setDisplay(deviceStatus.display);
    }, [deviceStatus.light_1, deviceStatus.light_2, deviceStatus.display]);


    function toggleLight1() {
        handleLight1Change(!light1, deviceID);
        setLight1(!light1);
    }

    function toggleLight2() {
        handleLight2Change(!light2, deviceID);
        setLight2(!light2);
    }

    function toggleDisplay() {
        handleDisplayChange(!display, deviceID);
        setDisplay(!display);
    }

    return (
        <>
            <FormGroup>
                <FormControlLabel
                    disabled={!online}
                    control={
                        <Switch
                            checked={light1}
                            onChange={toggleLight1}
                        />
                    }
                    label={t('deviceControls.light1')}
                />
                <FormControlLabel
                    disabled={!online}
                    control={
                        <Switch
                            checked={light2}
                            onChange={toggleLight2}
                        />
                    }
                    label={t('deviceControls.light2')}
                />
                <FormControlLabel
                    disabled={!online}
                    control={
                        <Switch
                            checked={display}
                            onChange={toggleDisplay}
                        />
                    }
                    label={t('deviceControls.display')}
                />
                {online && (
                    <div style={{ position: 'relative', marginTop: 16 }}>
                        <LinearProgress
                            variant="determinate"
                            value={deviceStatus.voltage / 14 * 100}
                            sx={{
                                height: 32,
                                borderRadius: 4,
                                '& .MuiLinearProgress-bar': {
                                    backgroundColor: '#44e600ff'
                                }
                            }}
                        />
                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: 16,
                                color: '#222',
                                fontWeight: 500,
                                pointerEvents: 'none'
                            }}
                        >
                            {t('deviceControls.voltage', { voltage: deviceStatus.voltage })}
                        </div>
                    </div>
                )}
            </FormGroup>
        </>
    );
}

export default DeviceControls;